import { render, staticRenderFns } from "./User-tab.vue?vue&type=template&id=56fed53b"
import script from "./User-tab.vue?vue&type=script&lang=js"
export * from "./User-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports